'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactScroll = require('react-scroll');
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _containers = require('../../containers');
var _packagesConfigs = require('../../containers/RealtorPackagesContainer/packagesConfigs');







var _components = require('../../components');

var _RealtorPackageWrapper = require('./RealtorPackageWrapper.scss');var styles = _interopRequireWildcard(_RealtorPackageWrapper);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var getStatisticsData = function getStatisticsData(translate) {return [
    { label: translate('sessions'), value: '340,000' },
    { label: translate('views'), value: '850,000' },
    { label: translate('calls'), value: '33,000' }];};var


RealtorPackageWrapper = function (_Component) {_inherits(RealtorPackageWrapper, _Component);
    function RealtorPackageWrapper(props) {_classCallCheck(this, RealtorPackageWrapper);var _this = _possibleConstructorReturn(this,
        _Component.call(this, props));_this.


















        changePropertiesCount = function (value) {
            _this.setState({ packageInstance: _this.findPackageByProperties(value) });
            _this.setState({ calculatorSelectedPropertiesCount: value });
        };_this.

        handleClickOk = function () {
            _this.props.hideMessageModal();
            _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/manage_properties'));
        };_this.

        openSuccessMessage = function () {
            _this.props.openMessageModal({
                message:
                _react2.default.createElement('div', { className: styles.successPromoted },
                    _react2.default.createElement('div', null, _this.props.rootTranslate('managePage', 'purchaseSuccessful')),
                    _react2.default.createElement('button', {
                            onClick: _this.handleClickOk,
                            className: 'btn btn-primary' },

                        _this.props.rootTranslate('publishProperty', 'ok'))) });




        };_this.

        handleSuccessPurchasePackage = function (paidProducts, setProcessOverlayState) {
            setProcessOverlayState(false);
            _this.openSuccessMessage();
        };_this.

        changePeriod = function (value) {var _this$state =
            _this.state,packageInstance = _this$state.packageInstance,isCalculator = _this$state.isCalculator;
            var selectedPeriod = _packagesConfigs.realtorPackagePeriods.find(function (item) {return item.value === +value;});
            packageInstance.changePeriod(selectedPeriod);
            if (isCalculator) {
                _this.changePackagesPeriod(selectedPeriod);
            }

            _this.forceUpdate();
        };_this.

        findPackageByProperties = function (count) {return _packagesConfigs.realtorPackages.
            find(function (pack) {return pack[_packagesConfigs.PROMOTIONS.PROPERTIES] === Number(count);}) ||
            _packagesConfigs.realtorPackages[0];};_this.


        renderTopBlock = function () {var
            translate = _this.props.translate;var
            packageInstance = _this.state.packageInstance;

            return (
                _react2.default.createElement('div', { className: styles.mobileTopBlock },
                    _react2.default.createElement('h4', null, translate('packages', 'selectAdsQuantity')),
                    _react2.default.createElement(_components.HomePagePropertiesChips, {
                        name: 'realtors-package-calculator-count-switch',
                        values: _packagesConfigs.getAdsCountValues,
                        selectedValue: String(packageInstance.properties),
                        onChange: _this.changePropertiesCount,
                        className: 'squareMobile' })));



        };_this.state = { isModalOpen: false, locale: _this.props.locale, statisticsData: getStatisticsData(props.translate), defaultPackageMessage: '', formattedPackagePeriods: (0, _packagesConfigs.getFormattedRealtorPackagePeriods)(props.translate('packages')), packageInstance: _this.findPackageByProperties('10'), isCalculator: false, calculatorSelectedPropertiesCount: '10' };return _this;}RealtorPackageWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (nextProps.locale !== this.props.locale) {this.setState({ statisticsData: getStatisticsData(nextProps.translate) });}};RealtorPackageWrapper.prototype.

    render = function render() {
        var translate = this.props.translate('packages');

        if (this.state.locale !== this.props.locale) {
            this.setState({
                formattedPackagePeriods: (0, _packagesConfigs.getFormattedRealtorPackagePeriods)(this.props.translate('packages')),
                locale: this.props.locale });

        }

        return (
            _react2.default.createElement('div', { className: styles.packagesWrapper },
                _react2.default.createElement('h2', { className: styles.title }, this.props.translate('packages', 'title')),
                _react2.default.createElement('div', { className: styles.packageSwitch },
                    _react2.default.createElement(_components.HomePagePropertiesChips, {
                        name: 'realtors_package_id_primary_switch',
                        values: this.state.formattedPackagePeriods,
                        selectedValue: this.state.packageInstance.currentPeriodValue.toString(),
                        onChange: this.changePeriod,
                        className: 'switcherPackages' }),

                    _react2.default.createElement('div', { className: styles.switcherDescription },
                        _react2.default.createElement('p', null, this.props.isRtl && _react2.default.createElement('span', null, translate('spin'))),
                        _react2.default.createElement('div', null,
                            _react2.default.createElement('p', null, translate('stock_2')),
                            _react2.default.createElement('p', { className: styles.stock }, translate('stock_1'))))),



                this.renderTopBlock(),
                _react2.default.createElement('div', { className: styles.packageItemWrapper },
                    _react2.default.createElement('div', { className: styles.points },
                        _packagesConfigs.PACKAGE_FEATURES_ORDER.map(function (item) {return (
                                _react2.default.createElement('p', null, translate(item)));})),


                    _react2.default.createElement(_containers.RealtorPackagesContainer, {
                        handlePurchase: this.handleSuccessPurchasePackage,
                        handleChoosePackage: this.props.handleChoosePackage,
                        onlyForAgents: true,
                        isPage: this.state.packageInstance._period,
                        calculatorSelectedPropertiesCount: this.state.calculatorSelectedPropertiesCount })),


                _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.couponWrapper) },
                    _react2.default.createElement(_containers.DiscountCouponContainer, {
                        inLanding: true,
                        contactUsRealtor: true,
                        updateCoupon: function updateCoupon() {} })),


                _react2.default.createElement('div', { className: styles.tax },
                    this.props.translate('withoutTax')),

                _react2.default.createElement(_reactScroll.Link, { className: styles.link, to: 'realtor-landing-contact-us', offset: -150, smooth: true },
                    this.props.translate('contactUsForSpecial'))));



    };return RealtorPackageWrapper;}(_react.Component);


RealtorPackageWrapper.propTypes = {
    translate: _propTypes2.default.func,
    rootTranslate: _propTypes2.default.func,
    handleChoosePackage: _propTypes2.default.func,
    openMessageModal: _propTypes2.default.func,
    hideMessageModal: _propTypes2.default.func,
    locale: _propTypes2.default.string,
    isRtl: _propTypes2.default.bool };exports.default =


RealtorPackageWrapper;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorPackagesWrapper/RealtorPackagesWrapper.js
// module id = 2889
// module chunks = 0